export const searchBasicWrapper = {
    ' > div:nth-child(1)': {
        flex: 1,
        fontWeight: 'bold',
        marginRight: '$searchAutocompleteResultTemplateChildHorizontal',
    },
    ' > div:nth-child(2)': {
        flex: 3,
        marginRight: '$searchAutocompleteResultTemplateChildHorizontal',
    },
    ' > div:nth-child(3)': {
        display: 'flex',
        flex: 1,
        fontWeight: 'bold',
        justifyContent: 'flex-end',
        textAlign: 'right',
    },
    'display': 'flex',
    'justifyContent': 'space-between',
    'width': '100%',
}

export const searchBasicActionWrapper = {
    ...searchBasicWrapper,
    ' > div:nth-child(1)': {
        flex: 0,
        marginRight: '$searchAutocompleteResultTemplateChildHorizontal',
    },
}

export const multiselectIconWrapper = {color: '$searchAutocompleteTextLighter'}

export const multiselectSelectedIconWrapper = {
    'color': '$searchAutocompleteTextLighter',
    'svg:nth-child(1)': {display: 'block'},
    'svg:nth-child(2)': {display: 'none'},
}

export const inviteesWrapper = {
    ' > div:nth-child(1)': {
        fontWeight: 'bold',
        marginRight: '$searchAutocompleteResultTemplateChildHorizontal',
    },
    ' > div:nth-child(2)': {
        '> div:nth-child(2)': {color: '$searchAutocompleteTextLighter'},
        'flex': 1,
        'marginRight': '$searchAutocompleteResultTemplateChildHorizontal',
    },
    ' > div:nth-child(3)': {
        display: 'flex',
        fontWeight: 'bold',
        justifyContent: 'flex-end',
        textAlign: 'right',
    },
    'alignItems': 'center',
    'display': 'flex',
    'justifyContent': 'space-between',
    'width': '100%',
}

export const inviteesNameWrapper = {
    '> div': {
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    'overflow': 'hidden',
    'paddingRight': '10px',
}

export const timezoneWrapper = {
    ' > div:nth-child(1)': {
        fontWeight: 'bold',
        marginRight: '$searchAutocompleteResultTemplateChildHorizontal',
        minWidth: '50px',
    },
    ' > div:nth-child(2)': {
        '> div:nth-child(2)': {color: '$searchAutocompleteTextLighter'},
        'flex': 1,
        'marginRight': '$searchAutocompleteResultTemplateChildHorizontal',
    },
    'alignItems': 'center',
    'display': 'flex',
    'width': '100%',
}
